function normalizeFrame(frame) {
  if (!frame || !frame.id) return null;
  return {
    id: String(frame.id),
    x: Number(frame.x) || 0,
    y: Number(frame.y) || 0,
    w: Number(frame.w) || 0,
    h: Number(frame.h) || 0,
    label: String(frame.label || ''),
  };
}

function framesEqual(a, b) {
  const left = normalizeFrame(a);
  const right = normalizeFrame(b);
  if (!left || !right) return false;
  return JSON.stringify(left) === JSON.stringify(right);
}

export function buildFrameOps(previousFrames = [], nextFrames = []) {
  const prevMap = new Map(
    (Array.isArray(previousFrames) ? previousFrames : [])
      .filter(item => item?.id != null)
      .map(item => [String(item.id), item])
  );
  const nextMap = new Map(
    (Array.isArray(nextFrames) ? nextFrames : [])
      .filter(item => item?.id != null)
      .map(item => [String(item.id), item])
  );
  const ops = [];
  for (const [id, frame] of nextMap.entries()) {
    const prev = prevMap.get(id);
    if (prev && framesEqual(prev, frame)) continue;
    ops.push({ kind: 'upsert', id, frame });
  }
  for (const id of prevMap.keys()) {
    if (nextMap.has(id)) continue;
    ops.push({ kind: 'remove', id });
  }
  return ops;
}
